import axios from 'axios'
import { getHeaders } from '@/tools/utils.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

export default {

  async list() {
    const headers = await getHeaders()
    return axios.get('cards', { headers })
  },

  async search(criterias) {
    const headers = await getHeaders()
    return axios.post('cards/search', criterias, { headers })
  },

  async getDetail(criterias) {
    const headers = await getHeaders();
    return axios.post('cards/detail', criterias, { headers })
  },

  async unmaskPan(criterias) {
    const headers = await getHeaders()
    return axios.post('cards/unmaskPan', criterias, { headers })
  },

  async activate(criterias) {
    const headers = await getHeaders()
    return axios.post('cards/activate', criterias, { headers })
  },

  async deactivate(criterias) {
    const headers = await getHeaders()
    return axios.post('cards/deactivate', criterias, { headers })
  },

  async block(criterias) {
    const headers = await getHeaders()
    return axios.post('cards/block', criterias, { headers })
  },

  async unblock(criterias) {
    const headers = await getHeaders()
    return axios.post('cards/unblock', criterias, { headers })
  }
}
